import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const HOME = [["home_address", "Address 1"], ["home_address2", "Address 2"], ["home_city", "City"], ["home_state", "State"], ["home_postal_code", "Postal Code"], ["home_country", "Country"]];
const OFFICE = [["office_address", "Office Address 1"], ["office_address2", "Office Address 2"], ["office_city", "Office City"], ["office_state", "Office State"], ["office_zip", "Office Postal Code"], ["office_country", "Office Country"]];
const AGENT = ["agent", "agency_owner"];

function Section({ title, note, fields, form, onChange, testId }) {
  return (
    <div className="rounded-lg border border-slate-200 p-3" data-testid={testId}>
      <p className="text-sm font-semibold text-slate-800">{title}</p>
      <p className="text-xs text-slate-500 mb-2">{note}</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {fields.map(([k, l]) => <div key={k}><Label className="text-xs">{l}</Label><Input value={form[k] || ""} onChange={(e) => onChange(k, e.target.value)} data-testid={`edit-${k}`} /></div>)}
      </div>
    </div>);
}

/** Home / Personal vs Office / Business address. Agents see Office first; everyone else sees Home first. */
export function AddressSections({ form, onChange, classifications = [] }) {
  const home = <Section key="h" title="Home / Personal Address" note="Personal/home address. This is separate from your office or agency location." fields={HOME} form={form} onChange={onChange} testId="edit-home-address" />;
  const office = <Section key="o" title="Office / Business Address" note="Business or office location associated with this person." fields={OFFICE} form={form} onChange={onChange} testId="edit-office-address" />;
  const isAgent = classifications.some((c) => AGENT.includes(c));
  const mig = form.address_migration;
  const leg = mig?.legacy;
  return (
    <div className="space-y-3">
      {form.address_review && leg && (
        <div className="rounded-lg border border-amber-200 bg-amber-50 p-2 text-xs text-amber-900" data-testid="edit-address-review">
          <b>{form.address_review}.</b> Previous address (kept for reference, read-only): {[leg.address, leg.address2, leg.city, [leg.state, leg.postal_code].filter(Boolean).join(" "), leg.country].filter(Boolean).join(", ")}
          {mig.rule ? ` — ${mig.rule}` : ""}. Enter it under Home or Office below if you know which it is.
        </div>)}
      {isAgent ? [office, home] : [home, office]}
    </div>);
}
